import React from "react";
import List from "@mui/material/List";
import StandardLabel from "../../helpers/StandardLabel";

const EmailList = ({
  label,
  children,
}) => {
  return (
    <List
      dense={true}
      width="100%"
      subheader={<StandardLabel labelText={label}/>}>
      {children}
    </List>
  );
};

export default EmailList;